export default class ServerIsDown extends Error {
  constructor (message) {
    super(message)
    this.name = 'ServerIsDown'
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/exceptions/ServerIsDown.js